module.exports = __webpack_public_path__ + "fonts/Pretendard-Bold.subset.0cc59186.woff2";